import { Box } from "@chakra-ui/react";
import React from "react";
import Header from "../../../../components/header";
import Banner from "./components/banner";
import KeyBenifits from "./components/keyBenifitsHomeSub";
import LetsTalk from "./components/letsTalkHomeSub";
import Footer from "../../../../components/footer";

const HomeSubPage = () => {
  return (
    <Box>
      <Header />
      <Banner />
      <KeyBenifits />
      <LetsTalk formName="Akru Home Learn More"/>
      <Footer />
    </Box>
  );
};

export default HomeSubPage;
